import React from "react";
import { Box, Heading } from "@indeed/ifl-components";
import { expressive } from "@indeed/ifl-tokens";
import { Grid, GridItem } from "components/grid";
import { ArticleCardMobile } from "components/cards/articleCardMobile";
import { ArticleCardStacked } from "components/cards/articleCardStacked";
import useResponsiveValue from "hooks/useResponsiveValues";
import type { Article } from "types/globals";

export interface ArticlesSecondaryProps {
  articles: Article[];
  heading: string;
}

export const ArticlesSecondary: React.FC<ArticlesSecondaryProps> = ({
  articles,
  heading,
}) => {
  const isMobile = useResponsiveValue([true, true, true, false]);

  const ResponsiveArticleCard = isMobile
    ? ArticleCardMobile
    : ArticleCardStacked;

  return (
    <Box sx={{ position: "relative", pb: ["56px", null, "80px"] }}>
      <Box
        sx={{
          display: ["none", null, null, "block"],
          position: "absolute",
          top: 0,
          right: "-10vw",
        }}
      >
        <svg
          width="360"
          height="165"
          viewBox="0 0 360 165"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0 164.85C0 164.85 3.89351 26.3221 129.376 66.0766C254.859 105.831 235.058 24.5404 319.603 3.82797C404.148 -16.9958 507.271 75.0965 499.596 164.85L0 164.85Z"
            fill={expressive.earth["300"]}
          />
        </svg>
      </Box>
      <Grid rowGap="32px">
        <GridItem>
          <Heading
            as="h2"
            sx={{
              fontWeight: 300,
              fontSize: ["32px", null, "56px"],
              lineHeight: 1.25,
            }}
          >
            {heading}
          </Heading>
        </GridItem>
        <GridItem>
          <Box>
            <Grid
              templateColumns={[null, null, null, "repeat(3, 3fr)"]}
              columnGap={[null, null, "5vw"]}
              rowGap="32px"
            >
              {articles.map((article) => (
                <GridItem key={article.title}>
                  <ResponsiveArticleCard
                    {...article}
                    sx={{ position: "relative", zIndex: 2 }}
                  />
                </GridItem>
              ))}
            </Grid>
          </Box>
        </GridItem>
      </Grid>
    </Box>
  );
};
